<template>
  <div class="content-panel">
    <div class="content-panel-close">
      <i class="os-icon os-icon-close"></i>
    </div>
    <div class="element-wrapper">
      <slot name="top" v-if="$slots.top"></slot>

      <div v-if="currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_MANAGER' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_HEAD_OF_AMDL' ||
                  currentUserRole === 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES' ||
                  currentUserRole === 'ROLE_PRACTICE_MANAGER' ||
                  currentUserRole === 'ROLE_HEAD_OF_OCCUPATIONAL_THERAPY' ||
                  currentUserRole === 'ROLE_HEAD_OF_MARKETING' ||
                  currentUserRole === 'ROLE_ACCOUNTANT' ||
                  currentUserRole === 'ROLE_ASSISTANT_VQ'">
        <div class="element-box-tp">
          <div class="el-buttons-list full-width">
            <div class="input-search-w">
              <form @submit.prevent="handleSearch" class="sidebar-search-form">
                <div class="search-wrapper">
                  <!-- Ikonica lupe na početku polja -->
                  <i class="fa-solid fa-magnifying-glass search-icon"></i>

                  <input
                      v-model="searchTerm"
                      class="form-control sidebar-search-input"
                      placeholder="Kunden suchen..."
                      type="search"
                  />
                </div>
              </form>
            </div>
            <hr>
            <router-link :to="{ name: 'unemployedForm'}" class="sidebar-action-btn">
              <i class="fa-solid fa-plus me-3"></i>
              Neuen Kunden hinzufügen
            </router-link>

            <router-link :to="{ name: 'unemployedNewAndActiveList'}" class="sidebar-action-btn">
              <i class="fa-solid fa-list-ul me-3"></i>
              Kunden- &amp; Patientenliste
            </router-link>
            <hr>
          </div>
        </div>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
import router from '@/router';
import {computed, ref} from 'vue';
import {piniaUserStore} from "@/store/piniaUserStore";
import {piniaCompanySettingsStore} from "@/store/piniaCompanySettingsStore";

const searchTerm = ref('');

const piniaUserState = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);
const piniaCompanySettingsState = piniaCompanySettingsStore();
const companySettings = computed(() => piniaCompanySettingsState.companySettings);

const currentUserRole = piniaCurrentUser.value.roles[0];

const companyColor = computed(() => companySettings.value?.colorCode || '#15803d');

const companyBgColor = computed(() => companySettings.value?.colorCode
    ? `${companySettings.value.colorCode}15`
    : '#ecfdf5'
)

function handleSearch() {
  router.push({
    name: 'unemployedNewAndActiveList',
    query: {
      searchTerm: searchTerm.value
    }
  })
}
</script>

<style scoped>
.sidebar-action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 7px 14px;
  margin-bottom: 10px;
  border-radius: 4px;
  color: #1e293b;
  font-size: 0.77rem;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.2s ease-in-out;
  cursor: pointer;

  /* Pozadina i okvir prate brend boje */
  background-color: v-bind(companyBgColor);
  border: 1px solid v-bind(companyColor);
}

.sidebar-action-btn i {
  font-size: 0.9rem;
  color: v-bind(companyColor); /* Ikona dobija boju brenda */
  margin-right: 5px;
  transition: transform 0.2s ease;
}

.sidebar-action-btn:hover {
  /* Lagano potamnjivanje pozadine na hover */
  background-color: v-bind(companyBgColor);
  filter: brightness(0.96);

  /* Okvir postaje malo prozirniji na hover po tvom originalnom dizajnu */
  border-color: v-bind(companyColor);
  opacity: 0.9;

  color: v-bind(companyColor); /* Tekst postaje tamniji u boji brenda */
}

.sidebar-action-btn:hover i {
  transform: scale(1.1);
}

.sidebar-action-btn:active {
  transform: scale(0.99);
  filter: brightness(0.91); /* Dodatni vizuelni feedback na klik */
}

.sidebar-search-form {
  margin-bottom: 16px;
}

.search-wrapper {
  position: relative;
  width: 100%;
}

.search-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  font-size: 0.9rem;
  pointer-events: none;
  transition: color 0.2s ease;
}

.sidebar-search-input {
  width: 100%;
  padding: 10px 16px 10px 40px !important;
  font-size: 0.88rem;
  font-weight: 500;
  color: #1e293b;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
  transition: all 0.2s ease-in-out;
}

.sidebar-search-input::placeholder {
  color: #94a3b8;
  font-weight: 400;
}

.sidebar-search-input:focus {
  background-color: #ffffff;
  border-color: v-bind(companyColor); /* Border inputa postaje brendiran */
  outline: none;

  /* Prilagođavamo sjenu (glow efekat) oko inputa koristeći boju kompanije sa 15% vidljivosti */
  box-shadow: 0 0 0 3px v-bind(companyBgColor) !important;
}

/* Kada je input fokusiran, lupa (search-icon) dobija boju kompanije */
.search-wrapper:focus-within .search-icon {
  color: v-bind(companyColor);
}

.sidebar-search-input::-webkit-search-decoration,
.sidebar-search-input::-webkit-search-cancel-button,
.sidebar-search-input::-webkit-search-results-button,
.sidebar-search-input::-webkit-search-results-decoration {
  display: none;
}
</style>